module.exports = __webpack_public_path__ + "img/blue_check.a782f928.svg";